import { render, staticRenderFns } from "./InjuryZoneChart.vue?vue&type=template&id=490cfca2"
import script from "./InjuryZoneChart.vue?vue&type=script&lang=js"
export * from "./InjuryZoneChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports